import script from "./AllowAccessOfficeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllowAccessOfficeModal.vue?vue&type=script&setup=true&lang=ts"

import "./AllowAccessOfficeModal.vue?vue&type=style&index=0&id=61975771&scooped=true&lang=css"

const __exports__ = script;

export default __exports__